module.exports = __webpack_public_path__ + "static/media/coachella-thumbnail.0529569a.jpg";